export interface ILiveMatchItem {
  id: string;
  text: string;
}

export const LIVE_MATCH_STRIP_ITEMS: ILiveMatchItem[] = [
  { id: '1', text: 'LIVE IND 184/3 (18.3) vs AUS' },
  { id: '2', text: 'LIVE IND 184/3 (18.3) vs AUS' },
  { id: '3', text: 'LIVE IND 184/3 (18.3) vs AUS' },
];
